export const arePoiGroupsEqual = (poiGroups1, poiGroups2) => {
    //same guard as areLinkedPOIsEqual below - missing means none, not a crash
    const groups1 = poiGroups1 ?? [];
    const groups2 = poiGroups2 ?? [];

    if (groups1.length !== groups2.length) return false; // Quick length check

    // Sort both arrays by POIGroupID
    const sortedGroups1 = groups1.slice().sort((a, b) => a.POIGroupID - b.POIGroupID);
    const sortedGroups2 = groups2.slice().sort((a, b) => a.POIGroupID - b.POIGroupID);

    // Compare POIGroupID of each item in sorted arrays
    for (let i = 0; i < sortedGroups1.length; i++) {
        if (sortedGroups1[i].POIGroupID !== sortedGroups2[i].POIGroupID) {
            return false;
        }
    }

    return true;
};


export const areLinkedPOIsEqual = (linkedPOIs1, linkedPOIs2) => {
    //a poi built from the createPOI response has no linkedPOIs field at all, so treat missing as empty
    //rather than throwing on .length - same convention as useFetchPoiOptions and PoiDialog
    const arr1 = linkedPOIs1 ?? [];
    const arr2 = linkedPOIs2 ?? [];

    if (arr1.length !== arr2.length) {

        return false;}

    const sorted1 = [...arr1].sort((a, b) => a.LPOIID - b.LPOIID);
    const sorted2 = [...arr2].sort((a, b) => a.LPOIID - b.LPOIID);

    return JSON.stringify(sorted1) === JSON.stringify(sorted2);
  };